<script>
    import {onMount, onDestroy} from 'svelte';
    import MenuItem from './MenuItem.svelte';

    export let items = [];
    export let width = '250px';
    export let position = {x: 0, y: 0};
    export let showMenu = false;

    function handleMouseDown(event){
        showMenu = false;
    }

    onMount(() => {
        window.addEventListener('mousedown', handleMouseDown);
    });

    onDestroy(() => {
         window.removeEventListener('mousedown', handleMouseDown);
    });
</script>

<style>
    .context-menu {
        border: 1px solid #e9ecef;
        padding: .5rem 0;
        position: absolute;
        background-color: white;
        -webkit-box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.23);
        z-index: 25;
    }
</style>

<div class="context-menu" style={`width: ${width}; left: ${position.x}px; top: ${position.y}px`}>
    {#each items as group, index}
        {#each group as item}
            {#if !item.hide}
            <MenuItem label={item.label} action={(event) => item.action(event, item)} disabled={item.disabled} />
            {/if}
        {/each}
        {#if index < items.length-1 && group.filter(i => !i.hide).length}
            <div class="dropdown-divider"></div>
        {/if}
    {/each}
</div>
